import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from 'vue';

import {
  ProductsViewHero,
  ProductsViewContent,
  ProductsViewFooter,
  ProductsViewError
} from './components';

import { EProductsViewStatus } from './types';
import {
  getHero,
  getSummary,
  IHero,
  ISummary
} from '@/modules/products/services/products';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsView',
  setup(__props) {

const status = ref(EProductsViewStatus.Loading);

const hero = ref<IHero>({} as IHero);
const summary = ref<ISummary>({
  products: Array(5).fill({}),
  services: []
} as ISummary);

const currentStatus = computed(() => ({
  isLoading: status.value === EProductsViewStatus.Loading,
  isError: status.value === EProductsViewStatus.Error
}));

const cards = computed(() => {
  return summary.value.products;
});

const services = computed(() => {
  return summary.value.services;
});

async function getProductsData() {
  try {
    status.value = EProductsViewStatus.Loading;

    const [header, content] = await Promise.all([getHero(), getSummary()]);

    hero.value = header;
    summary.value = content;
    status.value = EProductsViewStatus.Loaded;
  } catch {
    status.value = EProductsViewStatus.Error;
  }
}
onMounted(getProductsData);

return { __sfc: true,status, hero, summary, currentStatus, cards, services, getProductsData, ProductsViewHero, ProductsViewContent, ProductsViewFooter, ProductsViewError }
}

})